export default __webpack_public_path__ + "static/media/last4.b453970d.jpg";